import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import TradesIcon from '@interxfi/design-system/icons/react/icon-trades';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { IncreaseAccountNumberConfirmSyncAllDialog } from '../../../../../../../../../../features/vendor/increase/account-number/increase-account-number-sync-all-confirm-dialog';
import { IncreaseAccountNumbersTable } from '../../../../../../../../../../features/vendor/increase/account-number/increase-account-numbers-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/account-number/_account-number/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorIncrease,
      label: 'Account Numbers',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorIncrease>,
  head: () => getPageHead('Increase Account Numbers'),
  component: IncreaseAccountNumbersList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <IncreaseAccountNumberConfirmSyncAllDialog
              trigger={
                <Button affixIcon={<TradesIcon aria-hidden />} aria-label="Sync All Increase Account Numbers" size="small">
                  Sync All
                </Button>
              }
            />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorIncrease}
    />
  );
}

function IncreaseAccountNumbersList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <IncreaseAccountNumbersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
